<template>
  <v-radio-group v-model="newValue" :rules="rules" :row="row" :disabled="disabled" :class="{ 'disable': disabled }">
    <v-radio
      v-for="option in options"
      id="deleteOptions"
      :key="`delete_option_${option.value}`"
      :value="option.value"
      color="red"
      class="black--text"
      active-class="black--text"
      @click.stop
    >
      <template #label>
        <div class="black--text">{{ option.label }}</div>
      </template>
    </v-radio>
  </v-radio-group>
</template>

<script>
import { ref, watch } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default () {
        return [];
      }
    },
    rules: {
      type: Array,
      default () {
        return [];
      }
    },
    row: { type: Boolean, default: false },
    preventDefault: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  setup (props, context) {
    const newValue = ref(props.value);
    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    return { newValue };
  }
};
</script>
